import externalLinks from "./_externalLinks.js";
import partnerLoadMore from "./_partnerLoadMore.js";
import partnerHero from "./_partnerHero.js";
import studioSliders from "./_studioSliders.js";
import newsletterSignup from "./_newsletter.js";
import faqAccordion from "./_faqAccordion.js";
import testimonials from "./_testimonials.js";
import header from "./_header.js";
import mobileNav from "./_mobileNav.js";
import teamModals from "./_teamModals.js";
import eventsNav from "./_eventsNav.js";
import eventsFloating from "./_eventFloating.js";
import share from "./_share.js";

const init = () => {
  const modules = [
    externalLinks,
    partnerLoadMore,
    partnerHero,
    studioSliders,
    newsletterSignup,
    faqAccordion,
    testimonials,
    header,
    mobileNav,
    teamModals,
    eventsNav,
    eventsFloating,
    share,
  ];
  modules.forEach((mod) => {
    try {
      mod();
    } catch (err) {
      console.error(err);
    }
  });
};

if (document.readyState === "interactive") {
  init();
} else {
  window.addEventListener("DOMContentLoaded", init, false);
}
